<script lang="ts" setup>
import PrimeProgress from '@/components/UI/PrimeProgress.vue';
import { useSurveyStore } from '@/stores/survey';
import { storeToRefs } from 'pinia';

const surveyStore = useSurveyStore();

const { currentStep, totalSteps, getProgress } = storeToRefs(surveyStore);
</script>

<template>
	<div class="survey-progress container">
		<h6 :data-test-id="`questions-number-${currentStep}`">
			{{ $t('questions_of', { value: currentStep, total: totalSteps }) }}
		</h6>
		<PrimeProgress :value="getProgress" />
	</div>
</template>

<style lang="scss">
.survey-progress {
	padding-top: 1.5rem;
	padding-bottom: 1.5rem;

	h6 {
		margin-bottom: 0.375rem;
		color: var(--gray-600);
		font-size: var(--font-12);
		font-weight: 400;
	}
}
</style>
